import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { RallyIntelligenceState, RootState } from '../types';

const namespaced: boolean = true;

export const state: RallyIntelligenceState = {
	prompts: [],
	configuration: null,
	usage: null,
	fetchPromptsComplete: false
};

export const RallyIntelligence: Module<RallyIntelligenceState, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};

export default RallyIntelligence;
